<template>
  <fieldset :id="desc">
    <legend class="group-label">{{ rowDesc }}</legend>
    <br />
    <el-row type="flex" align="middle" justify="center" :gutter="5">
      <el-col :span="4">
        <el-input v-model="rowFrom"></el-input>
      </el-col>
      <el-col :span="4">
        <base-select
          id="from-unit-selector"
          :value="rowFromUnits"
          :options="rowUnitOptions"
          @set-new-value="rowFromUnits = $event.newValue"
        />
      </el-col>
      <el-col :span="1"><i class="calc-text el-icon-right" /></el-col>
      <el-col :span="4">
        <base-select
          id="to-unit-selector"
          :value="rowToUnits"
          :options="rowUnitOptions"
          @set-new-value="rowToUnits = $event.newValue"
        />
      </el-col>
      <el-col :span="1">=</el-col>
      <el-col class="calc-result" :span="6">{{ result }}</el-col>
    </el-row>
  </fieldset>
</template>
<script>
import { toRefs, reactive, computed } from "vue"
import { useStore } from "vuex"
import BaseSelect from "../../components/BaseSelect.vue"

export default {
  name: "ConversionRow",
  props: ["desc", "from", "fromUnits", "toUnits", "unitOptions"],
  components: { BaseSelect },
  setup(props) {
    const store = useStore()
    const state = reactive({
      rowFrom: props.from,
      rowFromUnits: props.fromUnits,
      rowToUnits: props.toUnits,
    })
    const decimalPlaces = computed(() => {
      return store.state.decimalPlaces
    })

    const rowDesc = computed(() => {
      let rdesc = props.desc
      rdesc = rdesc.charAt(0).toUpperCase() + rdesc.slice(1)
      return rdesc
    })

    const rowUnitOptions = computed(() => {
      var options = []
      for (const [opt, obj] of Object.entries(props.unitOptions)) {
        options.push({ value: opt, label: obj.abbr })
      }
      return options
    })

    const result = computed(() => {
      const conversionResult =
        Math.round(
          (state.rowFrom *
            props.unitOptions[state.rowFromUnits].conv *
            10 ** decimalPlaces.value) /
            props.unitOptions[state.rowToUnits].conv
        ) /
        10 ** decimalPlaces.value
      return (
        String(conversionResult) +
        " " +
        props.unitOptions[state.rowToUnits].abbr
      )
    })

    return {
      ...toRefs(state),
      rowDesc,
      rowUnitOptions,
      result,
    }
  },
}
</script>

<style lang="scss" scoped>
</style>